import { config } from '../config'

export interface APIAction<TPayload, TResult> {
    api: 'wc' | 'cocart' | 'wp' | 'addToCart'
    headers?: { [key: string]: string }
    method?: 'delete' | 'get' | 'post' | 'put'
    path: string
    payload?: FormData | undefined
}

export async function api<TBody, TResult>(action: APIAction<TBody, TResult>): Promise<TResult> {
    try {
        const absPath = new RegExp('^(?:[a-z]+:)?//', 'i')
        const url = absPath.test(action.path) ? new URL (action.path) : new URL(action.path, config.api.json[action.api])
        const body = action.payload ? action.payload : null
        const headers = action.api === 'wc'
            ? {'Authorization': 'Basic ' + Buffer.from(config.api.authentication.clientKey + ':' + config.api.authentication.clientSecret).toString('base64'), ...(action.headers || {})}
            : action.headers || {}
        //const params = { consumer_key: config.api.authentication.clientKey, consumer_secret: config.api.authentication.clientSecret }
        //Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
        const response = await fetch(url.href, {
            method: action.method || 'get',
            credentials: 'same-origin',
            body: body,
            headers: headers
        })
        return response.json()
    } catch (e) {
        //todo: handle common errors
        throw e
    }
}